import getPinterestVariantOptions from './pinterest';
import { updateZoomImg } from './carousel';

// local storage keys
const TITLEBOX_KEY = "titleBox";
const SIZE_KEY = "size";
const MATERIAL_KEY = "material";
const GIFT_CARD_KEY = "price";

// Get info of currently selected variant from list of variants on window object
export function getVariantInfo() {
  // if we have gift card buttons
  const giftCardButtons = document.getElementById("js_amount_buttons");
  if (giftCardButtons) {
    const cardIdx = giftCardButtons.querySelector(".selected").dataset.idx;
    return window.rambleMaps.productVariants[0][parseInt(cardIdx, 10)];
  }

  const sizeIdx = document.querySelector("#js_size_buttons .selected").dataset.idx;
  const materialId = document.querySelector("#js_material_buttons .selected").dataset.idx;
  const showTitleBox = document.querySelector("#js_title_checkbox");

  return window.rambleMaps.productVariants[sizeIdx]
    .find(({ material, titleBox }) => {
      if (showTitleBox) {
        return material === parseInt(materialId, 10) && titleBox === showTitleBox.checked;
      }
      return material === parseInt(materialId, 10);
    });
}

export function getVariantId(id) {
  const decodedSplitId = id.split("ProductVariant/");
  return decodedSplitId[1];
}

function setSessionStorageParameter(name, value) {
  /* eslint-disable prefer-const */
  if (window.sessionStorage) {
    const key = window.location.pathname;
    let params = JSON.parse(window.sessionStorage.getItem(key)) || {};
    params[name] = value;
    try {
      window.sessionStorage.setItem(key, JSON.stringify(params));
    } catch (e) {
      // This throws an error when the user's quota is exceeded (they've turned
      // off local storage, or are in incognito mode).
    }
  }
}

function setAddToCartActive(setActive) {
  const addToCart = document.getElementById("js_add_to_cart");
  if (setActive) {
    addToCart.innerHTML = "Add To Cart";
    addToCart.classList.remove("inactive");
    addToCart.disabled = false;
  } else {
    addToCart.innerHTML = "Unavailable Option";
    addToCart.classList.add("inactive");
    addToCart.disabled = true;
  }
}

// Used for showing an unselected option as unavailable
function markUnavailableOptions() {
  const selectedSize = document.querySelector("#js_size_buttons .selected")
  const sizeIdx = selectedSize && selectedSize.dataset && selectedSize.dataset.idx;
  if (sizeIdx) { // we don't have a size for gift cards
    const materials = document.querySelectorAll("#js_material_buttons button");
    const availableMaterialsAtSize = window.rambleMaps.productVariants[sizeIdx]
      .map(({material}) => material);

    materials.forEach(el => {
      if (!availableMaterialsAtSize.includes(parseInt(el.dataset.idx, 10))) {
        el.classList.add("unavailable");
      }
    });
  }
}

// Used when a variant has been selected that is not available
function markSelectedVariantUnavailable() {
  const shopifyPrice = document.getElementById("js_shopify_price");

  document.querySelector("#js_material_buttons .selected").classList.add("unavailable");
  shopifyPrice.innerHTML = "&nbsp;";
  window.rambleMaps.selectedVariant = null;
  setAddToCartActive(false);
}

// set button to selected, price, and selected variant
function updateOption(el, storageKey) {
  const shopifyPrice = document.getElementById("js_shopify_price");

  setSessionStorageParameter(storageKey, el.dataset.idx);
  el.classList.add("selected");

  const variantInfo = getVariantInfo();
  if (variantInfo) {
    const { price, id } = variantInfo;
    shopifyPrice.innerHTML = `$${price}`;
    setAddToCartActive(true);
    window.rambleMaps.selectedVariant = id;
    // make all option buttons active
    document.querySelectorAll("#js_size_buttons button").forEach(btn => {
      btn.classList.remove("unavailable");
    });
    document.querySelectorAll("#js_material_buttons button").forEach(btn => {
      btn.classList.remove("unavailable");
    });

    if (storageKey === MATERIAL_KEY) {
      updateMaterialPhoto(el.dataset.key);
      updateMaterialZoomImg(el.dataset.key);
    }

    markUnavailableOptions();
  // If not a valid option, inform user
  } else {
    markSelectedVariantUnavailable();
  }
}

// When we move between carousel slides we need to update the zoom image to the
// current slide. When we choose a material we need to update this image at the
// time we choose the material, but we also need to persist that selection. This
// state is stored in the dataset of an HTML node used by the carousel. This
// function updates the dataset entry of the relevant node for the chosen
// material
function updateMaterialZoomImg(key) {
  // update dataset of HTML node that we store the new material
  // key on for when we zoom
  const dots = document.querySelectorAll(".product_photo_dots .js_circle");
  if (dots && dots.length && dots.length > 3) {
    dots[3].dataset.productPhotoKey = key;
  }
}

function fireSelectOptionEvents(variantInfo) {
  if (variantInfo) {
    // a "custom" event is a specific label used in pinterest analytics to
    // capture an event that you want to include in conversion tracking
    // but doesn't otherwise fit into one of their other events
    window.pintrk('track', 'custom', getPinterestVariantOptions(variantInfo));

    // Create custom FB event, use same object as pinterest variant plus
    window.fbq('trackCustom', 'SelectOption', {
      content_type: 'product',
      contents: [{
        id: getVariantId(variantInfo.id),
        quantity: 1
      }],
    });

    window.gtag("event", "click", {
      event_category: "selectOption",
    });
  }
}

function updateWallPhoto(checked) {
  const wallPhoto = document.getElementById("js_wall_photo");
  const wallThumb = document.getElementById("js_wall_thumb");
  wallPhoto.src = window.rambleMaps.wallPhotos[checked ? "wall_with_title" : "wall"].src;
  wallPhoto.srcset = window.rambleMaps.wallPhotos[checked ? "wall_with_title" : "wall"].srcset;
  wallThumb.src = window.rambleMaps.wallPhotos[checked ? "wall_with_title" : "wall"].thumbnail;
}

function updateMaterialPhoto(key) {
  const materialPhoto = document.getElementById("js_material_photo");
  materialPhoto.src = window.rambleMaps.materialPhotos[key].src;
  materialPhoto.srcset = window.rambleMaps.materialPhotos[key].srcset;

  const materialThumb = document.getElementById("js_material_thumb");
  materialThumb.src = window.rambleMaps.materialPhotos[key].thumbnail;

}

function initTitlebox() {
  const titleCheckbox = document.getElementById("js_title_checkbox");
  if (titleCheckbox) {
    // init zoom image if checkbox state differs from markup
    updateWallPhoto(titleCheckbox.checked);
    updateZoomImg(titleCheckbox.checked ? "wall_with_title" : "wall");

    const variantInfo = getVariantInfo();
    if (variantInfo) {
      window.rambleMaps.selectedVariant = variantInfo.id;
    }
    // add event handler for checkbox

    titleCheckbox.addEventListener("change", () => {
      fireSelectOptionEvents(getVariantInfo());
      updateWallPhoto(titleCheckbox.checked);
      updateZoomImg(titleCheckbox.checked ? "wall_with_title" : "wall");
      setSessionStorageParameter(TITLEBOX_KEY, titleCheckbox.checked);
      window.rambleMaps.productPhotoCarousel.goTo(0);
    });
  }
}

// Select options based on sessionStorage. If no options present, use the
// first option.
function loadOptionFromStorageByType(storedParams, optionType) {
  const buttons = document.querySelectorAll(`#js_${optionType}_buttons button`);
  if (storedParams && storedParams[optionType] != null) {
    buttons.forEach(el => {
      const option = el.dataset.idx;
      if (option === storedParams[optionType]) {
        updateOption(el, optionType);
      } else {
        el.classList.remove("selected");
      }
    });
  } else if (buttons && buttons.length) {
    updateOption(buttons[0], optionType);
  }
}

function loadTitleboxFromStorage(storedParams) {
  const titleCheckbox = document.getElementById("js_title_checkbox");
  if (titleCheckbox && storedParams && storedParams[TITLEBOX_KEY] != null) {
    titleCheckbox.checked = storedParams[TITLEBOX_KEY];
  }
}

export default function selectOptions() {
  if (window.sessionStorage) {
    const storedParams =
      JSON.parse(window.sessionStorage.getItem(window.location.pathname));

    // Only run if we are on a product page
    if (window.rambleMaps.productVariants) {
      loadOptionFromStorageByType(storedParams, SIZE_KEY);
      const sizeButtons = document.querySelectorAll("#js_size_buttons button");
      sizeButtons.forEach(el => {
        el.addEventListener("click", () => {
          sizeButtons.forEach(btn => btn.classList.remove("selected"));
          updateOption(el, SIZE_KEY);
          fireSelectOptionEvents(getVariantInfo());
        });
      });

      loadOptionFromStorageByType(storedParams, MATERIAL_KEY);
      const materialButtons = document.querySelectorAll("#js_material_buttons button");
      // init material photo based on local storage
      materialButtons.forEach(el => {
        el.addEventListener("click", () => {
          materialButtons.forEach(btn => btn.classList.remove("selected"));
          updateOption(el, MATERIAL_KEY);
          fireSelectOptionEvents(getVariantInfo());
          updateMaterialPhoto(el.dataset.key);
          window.rambleMaps.productPhotoCarousel.goTo(3);

          // update zoom image
          updateZoomImg(el.dataset.key);
          updateMaterialZoomImg(el.dataset.key);
        });
      });

      loadOptionFromStorageByType(storedParams, GIFT_CARD_KEY);
      const giftCardAmountButtons = document.querySelectorAll("#js_amount_buttons button");
      giftCardAmountButtons.forEach(el => {
        el.addEventListener("click", () => {
          giftCardAmountButtons.forEach(btn => btn.classList.remove("selected"));
          updateOption(el, GIFT_CARD_KEY);
          fireSelectOptionEvents(getVariantInfo());
        });
      });

      loadTitleboxFromStorage(storedParams);
      initTitlebox();
    }
  }
}
